module.exports = __webpack_public_path__ + "static/img/401.0026ea27.gif";